import { FIELD_TYPES } from '../lib/constants';
import type { MapColorMode } from './ProjectSelectionContext';

/**
 * A single source of truth for routing between:
 * - Map "Color by" mode
 * - KPINavigator tab index
 * - KPIGrid externalFocusKpiField
 */

export type KpiFieldType = string;

export function tabIndexToField(tabIndex: number): KpiFieldType {
  const idx = typeof tabIndex === 'number' ? tabIndex : 0;
  switch (idx) {
    case 0:
      return FIELD_TYPES.SUMMARY;
    case 1:
      return FIELD_TYPES.SCHEDULE;
    case 2:
      return FIELD_TYPES.FINANCE;
    case 3:
      return FIELD_TYPES.MISSION;
    case 4:
      return FIELD_TYPES.DATA;
    default:
      return FIELD_TYPES.SUMMARY;
  }
}

export function fieldToTabIndex(field: KpiFieldType): number {
  const f = String(field || '').toLowerCase();
  if (f === String(FIELD_TYPES.SCHEDULE).toLowerCase()) return 1;
  if (f === String(FIELD_TYPES.FINANCE).toLowerCase()) return 2;
  if (f === String(FIELD_TYPES.MISSION).toLowerCase()) return 3;
  if (f === String(FIELD_TYPES.DATA).toLowerCase()) return 4;
  return 0;
}

export function mapModeToTabIndex(mode: MapColorMode | string | null | undefined): number {
  const m = String(mode || '').toLowerCase();
  if (m === 'schedule') return 1;
  if (m === 'finance') return 2;
  if (m === 'mission') return 3;
  if (m === 'data') return 4;
  return 0; // summary (default)
}

export function mapModeToField(mode: MapColorMode | string | null | undefined): KpiFieldType {
  return tabIndexToField(mapModeToTabIndex(mode));
}
